export default __webpack_public_path__ + "static/media/2385.bf858caf.png";